export const compose = <T>(fn1: (a: T) => T, ...fns: Array<(a: T) => T>) =>
  fns.reduce((prevFn, nextFn) => (value) => prevFn(nextFn(value)), fn1);

export const getPropertyFromObject = <T extends object, K extends keyof T, D extends T[K] | null>(
  obj: T,
  prop: K,
  defaultValue: D,
) => {
  return prop in obj ? obj[prop] ?? defaultValue : defaultValue;
};
